import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <motion.header
      className="bg-white/80 backdrop-blur-md border-b border-gray-200/50 sticky top-0 z-50"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto px-4 py-3 max-w-6xl flex items-center justify-between">
        <Link to="/" className="shrink-0">
          <img
            src="/logos/Logo-horizontal-Purple-Negro.png"
            alt="Código En Blanco"
            className="h-8 w-auto hidden md:block"
          />
          <img
            src="/logos/Icono-Purple.png"
            alt="Código En Blanco"
            className="h-8 w-auto block md:hidden"
          />
        </Link>
        <nav className="flex items-center gap-3">
          <Link
            to="/tours-virtuales"
            className="px-4 py-2 rounded-full bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 hover:shadow-md transition-all"
          >
            Tours Virtuales
          </Link>
          <Link
            to="/recorrido-aereo-1"
            className="px-4 py-2 rounded-full bg-purple-600 text-white text-sm font-semibold hover:bg-purple-700 hover:shadow-md transition-all"
          >
            Demo Aéreo
          </Link>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;
